import { render } from "./audit-log-item.vue?vue&type=template&id=9d82dc98"
import script from "./audit-log-item.vue?vue&type=script&lang=js"
export * from "./audit-log-item.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__